<template>
  <div class="modal-dim on">
    <!--'on 추가'-->
    <div class="modal-wrap">
      <div class="modal-inner whole">
        <div class="modal">
          <header class="header">
            <div class="inner">
              <h1 class="ttl">{{ isEmpty(regData.addressNo) ? '주소 상세' : '주소 수정' }}</h1>
              <div class="right" style="padding-left: 5px">
                <button class="header-btn" @click="close()"><i class="ico-close-gray90"></i></button>
              </div>
            </div>
          </header>

          <board-title-wrap :title="getAddressCity(regData.address)" :writer="regData.roadAddress" />
          <div class="modal-con">
            <input-component
              name="상세 주소"
              :required="false"
              place-holder="상세 주소를 입력해주세요"
              v-model="regData.addressDetail"
            />

            <div class="map-wrap">
              <!-- * 카카오맵 - 지도 -->
              <div class="map">
                <div id="kakao-map" class="root_daum_roughmap root_daum_roughmap_landing"></div>
              </div>
            </div>
          </div>
          <basic-button
            :single-text="isEmpty(regData.addressNo) ? '주소 등록하기' : '주소 수정하기'"
            inner-class="btm"
            btn-inner-class="primary large"
            @click="save"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useStore } from 'vuex';
import BoardTitleWrap from '@/components/common/layouts/BoardTitleWrap.vue';
import Validation from '@/components/common/layouts/Validation.vue';
import InputComponent from '@/components/common/input/InputComponent.vue';
import { defineProps, onBeforeMount, onMounted, reactive } from 'vue';
import BasicButton from '@/components/common/layouts/BasicButton.vue';
import { getAddressCity, getImagePath, isEmpty } from '@/common/utils/Util';
import ConstCode from '@/common/constants/ConstCode';
import { showTextModal } from '@/common/utils/ModalState';

const store = useStore();
const props = defineProps(['data']);
const emits = defineEmits(['close']);
const regData = reactive({ ...props.data.regData });

let mapContainer = null;
onMounted(() => {
  kakaoInjection();
});

const kakaoInjection = () => {
  return new Promise(resolve => {
    if (window.kakao && window.kakao.maps) {
      initMap(regData.latitude, regData.longitude);
      resolve();
    } else {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.src = `//dapi.kakao.com/v2/maps/sdk.js?autoload=false&appkey=${ConstCode.CODE_ENV_LIST.KAKAO_KEY}&libraries=services`;
      script.onload = () => {
        kakao.maps.load(() => {
          initMap(regData.latitude, regData.longitude);
          resolve();
        });
      };
      document.head.appendChild(script);
    }
  });
};

const initMap = async (latitude, longitude) => {
  let staticMapContainer = document.getElementById('kakao-map');
  let staticMapOption = {
    level: 4,
    center: new kakao.maps.LatLng(latitude, longitude)
  };
  mapContainer = new kakao.maps.Map(staticMapContainer, staticMapOption);
  mapContainer.setDraggable(true);
  mapContainer.setCenter(new kakao.maps.LatLng(regData.latitude, regData.longitude));

  displayMarker();
};

const displayMarker = () => {
  const position = new kakao.maps.LatLng(regData.latitude, regData.longitude);
  const marker = new kakao.maps.Marker({
    map: mapContainer,
    position: position,
    image: new kakao.maps.MarkerImage(getImagePath('pointer-map-focus.svg', 'origin/map'), new kakao.maps.Size(40, 40))
  });
};

const save = async () => {
  if (await store.dispatch('business/saveAddress', regData)) {
    const condition = store.getters['business/getAddressCondition'];
    condition.page = 1;
    store.commit('business/addressCondition', condition);
    store.dispatch('business/getAddressList');
    showTextModal('등록이 완료되었습니다.', '확인', () => {
      close();
    });
  }
};
const close = () => {
  setTimeout(() => {
    emits('close');
  }, 200);
};
</script>

<style scoped></style>
